import React, { useCallback } from "react";
import { Input } from "antd";
import { useEmployee } from "../../app/hooks/useEmployee";
import { debounce } from "lodash";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";


const SearchBar = () => {
  const { find, mutate } = useEmployee();

  const { employeeStore } = useStore();
  const {
    setSearchEmployeeText,
    setSearchEmployeeResults,
    searchEmployeeText,
  } = employeeStore;

  const debouncedSearch = useCallback(
    debounce(async (value) => {
      if (value.trim() !== "") {
        const res = await find(value);
        setSearchEmployeeResults(res);
      } else {
        setSearchEmployeeResults([]);
        mutate(); // This will revalidate the employee data
      }
    }, 500), // 500ms debounce
    []
  );
  return (
    <>
      <Input
        className="flex-1 "
        placeholder="Search Employee"
        allowClear
        value={searchEmployeeText}
        onChange={(e) => {
          const value = e.target.value;
          setSearchEmployeeText(value);
          debouncedSearch(value);
        }}
      />
    </>
  );
};

export default observer(SearchBar);
